import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "w-100 py-2 px-10 mt-4 mb-2 mx-0",
  style: {"height":"100px","display":"flex","justify-content":"center"}
}


import { useSettingsStore } from '@/api/store/settings';

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeBranding',
  props: {
    image: {
        type: String as () => string | null,
        default: null
    }
},
  setup(__props) {

const settingsStore = useSettingsStore();



return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_img, {
      src: __props.image ?? _unref(settingsStore).settings.brandingImg,
      class: "mx-auto",
      style: {"min-height":"80px"}
    }, null, 8, ["src"])
  ]))
}
}

})